import { render } from "./org-setting.vue?vue&type=template&id=eb397040&scoped=true"
import script from "./org-setting.vue?vue&type=script&lang=js"
export * from "./org-setting.vue?vue&type=script&lang=js"

import "./org-setting.vue?vue&type=style&index=0&id=eb397040&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb397040"]])

export default __exports__